export default function Brand({ brand, light = false }) {
  if (brand.key === "serviceboss") {
    return (
      <a className="brand brand-image-link" href="/" aria-label={`${brand.name} home`}>
        <svg className="brand-logo" viewBox="20 85 370 60" role="img" aria-label={brand.name}>
          <image href="/serviceboss.svg" width="400" height="233" />
        </svg>
      </a>
    );
  }

  if (brand.key === "servicelad") {
    return (
      <a className="brand brand-image-link" href="/" aria-label={`${brand.name} home`}>
        <picture>
          <source srcSet="/servicelad.webp" type="image/webp" />
          <img className="brand-logo servicelad-logo" src="/servicelad.png" alt={brand.name} />
        </picture>
      </a>
    );
  }

  if (brand.key === "servicebyreg") {
    return (
      <a className="brand brand-image-link sbr-brand-container" href="/" aria-label={`${brand.name} home`}>
        <img className="brand-logo servicebyreg-logo" src="/servicebyreg.svg" alt={brand.name} />
        <span className="sbr-brand-slogan">Vehicle history. Simplified.</span>
      </a>
    );
  }

  return (
    <a className="brand" href="/" aria-label={`${brand.name} home`} style={light ? { color: "white" } : undefined}>
      <span className="brand-mark" aria-hidden="true" />
      {brand.name}
    </a>
  );
}
